import { css } from "@emotion/css";
import type { IconSize } from "@octopusdeploy/design-system-icons";
import React from "react";
import { getIconStyles } from "../utils";
/**
 * Fallback icon for project avatars.
 * This does not use an icon from the Design System Icon package.
 * It is a custom SVG to match the existing user selected icons. Eventually we would like to replace this with a Design System Icon.
 * It has not been added to the package because it is not an icon we would like people to use outside of the tenant avatar.
 */
export interface AvatarFallbackProjectIconProps {
    size: IconSize;
}
export function AvatarFallbackProjectIcon({ size }: AvatarFallbackProjectIconProps) {
    const iconStyles = getIconStyles(size);
    return (<div className={iconStyles}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" aria-label="Project Icon" role="img" className={iconSvgStyles}>
                <path fill="currentColor" d="m12.38 25.26-1.75-1.75a1.73 1.73 0 0 1-.4-1.8c.18-.5.4-1.12.63-1.91H4.95c-.5 0-.96-.23-1.18-.68-.28-.39-.28-.9 0-1.35l2.92-4.95a4.11 4.11 0 0 1 3.5-2.02h4.66c.11-.23.22-.4.4-.62 4.6-6.8 11.47-7.03 15.52-6.24.67.11 1.18.62 1.3 1.3.78 4.04.55 10.9-6.25 15.52-.23.16-.4.28-.62.39v4.67c0 1.4-.79 2.75-2.02 3.49l-4.95 2.92c-.46.28-.96.28-1.36 0-.45-.22-.67-.67-.67-1.18v-6.02c-.84.28-1.52.5-2.02.68-.62.22-1.36.05-1.8-.45ZM25.2 13.05c1.24 0 2.25-.96 2.25-2.25a2.26 2.26 0 0 0-2.25-2.25 2.22 2.22 0 0 0-2.25 2.25c0 1.3.96 2.25 2.25 2.25Z"/>
            </svg>
        </div>);
}
// Added in to address some alignment issues with SVGs in some locations within the application
// due to inheritence problems from the parent CSS.
const iconSvgStyles = css({
    display: "block",
});
